import { createAsyncThunk } from '@reduxjs/toolkit';
import { selectSelectedProject } from 'store/projects/selectors/projectsSelectors';
import { updateCompanyName as updateCompanyNameService } from '../services/updateCompanyName.service';

export const updateCompanyName = createAsyncThunk(
  'expenseTracking/updateCompanyName',
  async ({ company_bid, company_name }, { getState }) => {
    const project = selectSelectedProject(getState());
    const businessId = project?.business_id;
    const projectId = project?.id;

    if (!businessId || !projectId || !company_bid) {
      throw new Error('Missing project context for company name update');
    }

    const response = await updateCompanyNameService(businessId, company_bid, {
      project: projectId,
      company_name,
    });

    return response;
  }
);
